<kendo-card class="json-department-card" >
  <kendo-card-header >
    <div>
      <h1 kendoCardTitle >
        <span *ngIf="filelinkBack != 9999" class="card_icon k-icon k-i-undo k-color-primary k-icon-md" (click)="ZoomInCard(filelinkBack)"></span>
        <span class="card_icon k-icon k-i-home k-color-primary k-icon-md" (click)="Home()"></span>
       Special valve overview
        <span class="card_icon k-icon k-i-redo k-color-primary k-icon-md" (click)="ZoomInCard(123)"></span>
      </h1>
      <div kendoCardSubtitle>
        <div id="wrap">
        </div>
      </div>
    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body >

    <span class="card_icon k-icon k-i-redo k-color-primary k-icon-md" (click)="ZoomInCard(123)"></span>
    To valve overview

  </kendo-card-body>
  <kendo-card-footer>
  </kendo-card-footer>

</kendo-card>



